// import { PageRipper } from '../utils/page-ripper.js';

// // Initialize page ripper with custom distance
// const pageRipper = new PageRipper({
//     distance: '45vw' // You can change this value as needed
// });

const navToggle = document.querySelector('.nav-main__toggle');
const navMain = document.querySelector('.nav-main__menu');
const mainContent = document.querySelector('main');

if (navToggle && navMain) {
    navToggle.addEventListener('click', () => {

        
        // Toggle navigation classes
        navMain.classList.toggle('nav-open');
        navToggle.classList.toggle('nav-open');
        mainContent.classList.toggle('nav-open');

    });
}